/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_TrialingInputs */



/**
* | output |
* | --- |
* | "Trialing" |
*
* @param {Subscription_TrialingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_trialing = /** @type {((inputs?: Subscription_TrialingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_TrialingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Essai")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erprobung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prova")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Испытание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Prueba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("试验")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परीक्षण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Testando")
	return /** @type {LocalizedString} */ ("Trialing")
});